import {k} from './kaplay.js'
import {click} from './music.js'

export function makeButton(_text, _pos, _isPrimary = true) {
  const btnSprite = _isPrimary ? "button" : "button_secondary"

  const btn = k.add([
    k.sprite(btnSprite),
    k.anchor("center"),
    k.pos(_pos),
    k.area()
  ])

  btn.add([
    k.text(_text, {
      size: 30,
      font: "black",
      align: "center"
    }),
    k.anchor("center"),
    k.color(k.BLACK),
    k.pos(0, -5)
  ])

  return btn
}

export function makeCaseStudyPanel(_pos, {title, content, linkUrl}) {
  const caseStudy = k.add([
    k.sprite("panel", {width: 530, height: 430}),
    // k.rect(300, 300),
    // k.outline(2, k.BLACK),
    k.anchor("top"),
    k.pos(_pos)
  ])

  const caseStudyTitle = caseStudy.add([
    k.text(title.toUpperCase(), {size: 30, font: "black", letterSpacing: 1.2, align: "center"}),
    k.color(k.BLACK),
    k.anchor("top"),
    k.pos(0, 40)
])

  const caseStudyContent = caseStudy.add([
    k.text(content, {width: 450, size: 30, align: "center", lineSpacing: 14}),
    k.color(k.BLACK),
    k.anchor("top"),
    k.pos(0, 100)
  ])

  // const caseStudyLink = makeButton("LEARN MORE", k.vec2(k.width()/2, caseStudyContent.pos.y + caseStudyContent.height + 60), false)
  const caseStudyLink = makeButton("LEARN MORE", k.vec2(k.width()/2, 340))
  caseStudyLink.setParent(caseStudy, {keep: k.KeepFlags.Pos})
  caseStudyLink.pos.y = 340
  caseStudyLink.onClick(() => {
    click.play()
    alert("Opens case study site, or\nShow lead capture form to send case study to")
  })

  return caseStudy
}

